import React from 'react';
import {
  Truck,
  Headphones,
  RotateCcw,
  BadgeCheck,
  CheckCircle2,
  ChevronRight,
  Store,
  ShieldCheck,
  Leaf,
  PackageCheck,
} from 'lucide-react';
import { Link } from 'react-router-dom';
import aboutImageLast from "../assets/images/about.jpeg";
import aboutDepozit from "../assets/images/depozit.webp";
import aboutShipping from "../assets/images/poza3.jpeg";
import aboutShipping2 from "../assets/images/poza4.jpeg";
import aboutFirst from "../assets/images/poza1.jpeg";
import { useLanguage } from '../context/LanguageContext';
import SEO from '../components/SEO';

const AboutUsPage = () => {
  const { language } = useLanguage();
  const isRu = language === 'ru';

  const text = {
    ro: {
      home: 'Acasă',
      page: 'Despre noi',
      badge: 'AgroSmart.md',
      title: 'Partenerul tău pentru produse agricole și gospodărești de calitate',
      desc: 'AgroSmart.md este magazinul online creat pentru oamenii care vor produse utile, durabile și ușor de comandat pentru grădină, gospodărie, construcții ușoare și lucrări agricole.',
      missionTitle: 'Misiunea noastră',
      missionDesc:
        'Ne dorim să aducem mai aproape de fiecare client produse practice, verificate și accesibile. Selectăm atent articolele din catalog, colaborăm cu furnizori de încredere și punem accent pe consultanță corectă, livrare rapidă și experiență simplă de cumpărare.',
      visionTitle: 'Viziunea noastră',
      visionDesc:
        'Vrem ca AgroSmart.md să devină una dintre cele mai comode platforme din Moldova pentru achiziția produselor agricole și gospodărești, unde clientul găsește rapid produsul potrivit și primește suport real înainte de comandă.',
      stats: [
        ['15+', 'ani experiență în domeniu'],
        ['10K+', 'clienți deserviți'],
        ['1000+', 'produse disponibile'],
        ['24/7', 'comenzi online'],
      ],
      prioritiesTitle: 'Ce contează pentru noi',
      prioritiesDesc: 'Calitate, corectitudine și ajutor real pentru fiecare comandă.',
      priorities: [
        {
          icon: Truck,
          title: 'Livrare rapidă',
          desc: 'Trimitem comenzile rapid prin metode de livrare comode în toată Moldova.',
        },
        {
          icon: Headphones,
          title: 'Consultanță utilă',
          desc: 'Te ajutăm să alegi produsul potrivit pentru necesitatea ta.',
        },
        {
          icon: RotateCcw,
          title: 'Comandă simplă',
          desc: 'Proces clar, rapid și ușor de înțeles, de la alegere până la livrare.',
        },
      ],
      productsTitle: 'Produse alese pentru gospodărie, grădină și lucrări agricole',
      productsDesc:
        'Catalogul AgroSmart include produse pentru lucrări sezoniere, întreținerea gospodăriei, grădinărit, irigare, unelte, accesorii și alte soluții utile pentru clienții care apreciază calitatea și prețul corect.',
      features: [
        'Produse selectate de la furnizori verificați.',
        'Informații clare despre preț, disponibilitate și caracteristici.',
        'Categorii organizate ca să găsești rapid ce ai nevoie.',
        'Suport înainte de cumpărare pentru alegerea corectă.',
      ],
      whyTitle: 'De ce să alegi AgroSmart.md?',
      whyDesc:
        'Pentru că vrem să oferim o experiență simplă și sigură: produse afișate clar, prețuri transparente, livrare comodă și suport atunci când ai nevoie de o recomandare.',
      whyItems: [
        'Prețuri clare și oferte actualizate.',
        'Branduri și produse verificate.',
        'Livrare prin curier sau ridicare personală.',
        'Echipă orientată spre client și soluții practice.',
      ],
      valuesTitle: 'Valorile AgroSmart',
      values: [
        {
          icon: ShieldCheck,
          title: 'Încredere',
          desc: 'Punem accent pe produse verificate și comunicare corectă.',
        },
        {
          icon: PackageCheck,
          title: 'Disponibilitate',
          desc: 'Actualizăm constant catalogul și stocurile.',
        },
        {
          icon: Leaf,
          title: 'Practic',
          desc: 'Alegem produse utile pentru munca de zi cu zi.',
        },
        {
          icon: BadgeCheck,
          title: 'Calitate',
          desc: 'Selectăm articole care oferă valoare reală.',
        },
      ],
      ctaTitle: 'Ai nevoie de ajutor la alegerea produsului?',
      ctaDesc:
        'Contactează-ne și îți recomandăm varianta potrivită pentru gospodăria, grădina sau proiectul tău.',
      ctaButton: 'Contactează-ne',
    },
    ru: {
      home: 'Главная',
      page: 'О нас',
      badge: 'AgroSmart.md',
      title: 'Ваш партнер для качественных товаров для сада, дома и хозяйства',
      desc: 'AgroSmart.md — это интернет-магазин для тех, кто ищет практичные, надежные и удобные в заказе товары для сада, хозяйства, легких строительных работ и сельского дела.',
      missionTitle: 'Наша миссия',
      missionDesc:
        'Мы хотим сделать полезные и проверенные товары ближе к каждому клиенту. Мы внимательно подбираем ассортимент, сотрудничаем с надежными поставщиками и делаем акцент на честной консультации, быстрой доставке и простом процессе покупки.',
      visionTitle: 'Наше видение',
      visionDesc:
        'Мы стремимся сделать AgroSmart.md одной из самых удобных платформ в Молдове для покупки товаров для сада и хозяйства, где клиент быстро находит нужный товар и получает реальную помощь перед заказом.',
      stats: [
        ['15+', 'лет опыта'],
        ['10K+', 'обслуженных клиентов'],
        ['1000+', 'товаров в каталоге'],
        ['24/7', 'онлайн-заказы'],
      ],
      prioritiesTitle: 'Что для нас важно',
      prioritiesDesc: 'Качество, честность и реальная помощь при каждом заказе.',
      priorities: [
        {
          icon: Truck,
          title: 'Быстрая доставка',
          desc: 'Отправляем заказы удобными способами доставки по всей Молдове.',
        },
        {
          icon: Headphones,
          title: 'Полезная консультация',
          desc: 'Помогаем выбрать подходящий товар под вашу задачу.',
        },
        {
          icon: RotateCcw,
          title: 'Простой заказ',
          desc: 'Понятный и быстрый процесс от выбора товара до доставки.',
        },
      ],
      productsTitle: 'Товары для дома, сада и сельскохозяйственных работ',
      productsDesc:
        'Каталог AgroSmart включает товары для сезонных работ, ухода за хозяйством, садоводства, полива, инструменты, аксессуары и другие полезные решения для клиентов, которые ценят качество и справедливую цену.',
      features: [
        'Товары от проверенных поставщиков.',
        'Понятная информация о цене, наличии и характеристиках.',
        'Удобные категории для быстрого поиска.',
        'Поддержка перед покупкой для правильного выбора.',
      ],
      whyTitle: 'Почему выбирают AgroSmart.md?',
      whyDesc:
        'Потому что мы хотим предложить простой и безопасный опыт покупки: понятная карточка товара, прозрачные цены, удобная доставка и помощь, когда нужна рекомендация.',
      whyItems: [
        'Понятные цены и актуальные предложения.',
        'Проверенные бренды и товары.',
        'Доставка курьером или самовывоз.',
        'Команда, ориентированная на клиента и практичные решения.',
      ],
      valuesTitle: 'Ценности AgroSmart',
      values: [
        {
          icon: ShieldCheck,
          title: 'Доверие',
          desc: 'Мы делаем акцент на проверенных товарах и честной коммуникации.',
        },
        {
          icon: PackageCheck,
          title: 'Доступность',
          desc: 'Постоянно обновляем каталог и наличие товаров.',
        },
        {
          icon: Leaf,
          title: 'Практичность',
          desc: 'Выбираем товары, полезные в ежедневной работе.',
        },
        {
          icon: BadgeCheck,
          title: 'Качество',
          desc: 'Подбираем товары, которые дают реальную ценность.',
        },
      ],
      ctaTitle: 'Нужна помощь с выбором товара?',
      ctaDesc:
        'Свяжитесь с нами, и мы подскажем подходящий вариант для дома, сада или вашего проекта.',
      ctaButton: 'Связаться',
    },
  };

  const c = isRu ? text.ru : text.ro;

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title={c.page}
        description={c.desc}
        breadcrumbs={[
          { name: c.home, url: '/' },
          { name: c.page, url: '/despre-noi' },
        ]}
      />

      <div className="bg-white border-b">
        <div className="w-full px-3 md:px-6 py-4">
          <div className="flex items-center gap-2 text-sm text-gray-600 overflow-x-auto whitespace-nowrap">
            <Link to="/" className="hover:text-[#a7cf26]">
              {c.home}
            </Link>
            <ChevronRight className="w-4 h-4 text-gray-400" />
            <span className="text-gray-900 font-semibold">{c.page}</span>
          </div>
        </div>
      </div>

      <div className="w-full px-3 md:px-6 py-8 md:py-10">
        <section className="grid grid-cols-1 lg:grid-cols-[1.05fr_0.95fr] gap-6 md:gap-8 items-stretch">
          <div className="bg-white border border-gray-100 rounded-[28px] p-5 md:p-8 flex flex-col justify-between">
            <div>
              <div className="inline-flex items-center gap-2 rounded-full bg-[#a7cf26]/10 px-4 py-2 text-xs font-black uppercase tracking-[0.16em] text-[#7fa20f]">
                <Store className="w-4 h-4" />
                {c.badge}
              </div>

              <h1 className="mt-5 text-3xl md:text-5xl font-extrabold leading-tight text-gray-950 max-w-[760px]">
                {c.title}
              </h1>

              <p className="mt-5 text-sm md:text-base leading-7 text-gray-500 max-w-[720px]">
                {c.desc}
              </p>
            </div>

            <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-3">
              {c.stats.map(([value, label]) => (
                <div
                  key={label}
                  className="rounded-2xl bg-gray-50 border border-gray-100 p-4 text-center"
                >
                  <div className="text-2xl md:text-3xl font-black text-[#a7cf26]">
                    {value}
                  </div>
                  <div className="mt-1 text-xs md:text-sm font-semibold text-gray-500">
                    {label}
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="relative min-h-[340px] md:min-h-[520px] overflow-hidden rounded-[28px] bg-white border border-gray-100">
            <img
              src={aboutDepozit}
              alt="AgroSmart"
              className="absolute inset-0 w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-black/15" />
            <div className="absolute left-5 right-5 bottom-5 rounded-[22px] bg-white/95 p-4 md:p-5">
              <p className="text-sm md:text-base font-bold text-gray-900">
                {c.missionTitle}
              </p>
              <p className="mt-2 text-xs md:text-sm leading-6 text-gray-500">
                {c.missionDesc}
              </p>
            </div>
          </div>
        </section>

        <section className="mt-6 md:mt-8 grid grid-cols-1 lg:grid-cols-[0.85fr_1.15fr] gap-6 md:gap-8">
          <div className="bg-white border border-gray-100 rounded-[28px] p-5 md:p-7">
            <h2 className="text-2xl md:text-3xl font-extrabold text-gray-950">
              {c.visionTitle}
            </h2>
            <p className="mt-4 text-sm md:text-base leading-7 text-gray-500">
              {c.visionDesc}
            </p>

            <div className="mt-6 overflow-hidden rounded-[24px] bg-gray-50 border border-gray-100 h-[250px] md:h-[330px]">
              <img
                src={aboutFirst}
                alt="AgroSmart"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          <div className="bg-white border border-gray-100 rounded-[28px] p-5 md:p-7">
            <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-3 mb-5">
              <div>
                <h2 className="text-2xl md:text-3xl font-extrabold text-gray-950">
                  {c.prioritiesTitle}
                </h2>
                <p className="mt-2 text-sm text-gray-500">{c.prioritiesDesc}</p>
              </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-3 md:gap-4">
              {c.priorities.map((item) => {
                const Icon = item.icon;

                return (
                  <div
                    key={item.title}
                    className="rounded-[22px] border border-gray-100 bg-gray-50 p-5"
                  >
                    <div className="flex h-11 w-11 items-center justify-center rounded-2xl bg-[#a7cf26]/10">
                      <Icon className="w-5 h-5 text-[#a7cf26]" />
                    </div>

                    <h3 className="mt-4 text-base font-extrabold text-gray-900">
                      {item.title}
                    </h3>

                    <p className="mt-2 text-sm leading-6 text-gray-500">
                      {item.desc}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </section>

        <section className="mt-6 md:mt-8 grid grid-cols-1 lg:grid-cols-[1fr_1fr] gap-6 md:gap-8 items-center">
          <div className="bg-white border border-gray-100 rounded-[28px] p-5 md:p-8">
            <h2 className="text-2xl md:text-4xl font-extrabold leading-tight text-gray-950">
              {c.productsTitle}
            </h2>

            <p className="mt-5 text-sm md:text-base leading-7 text-gray-500">
              {c.productsDesc}
            </p>

            <div className="mt-6 space-y-3">
              {c.features.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 w-5 h-5 text-[#a7cf26] flex-shrink-0" />
                  <p className="text-sm md:text-base leading-6 font-medium text-gray-700">
                    {item}
                  </p>
                </div>
              ))}
            </div>
          </div>

          <div className="grid grid-cols-[1.05fr_0.8fr] gap-3 md:gap-5 items-center">
            <div className="h-[320px] md:h-[470px] rounded-[26px] overflow-hidden bg-white border border-gray-100">
              <img
                src={aboutShipping}
                alt="AgroSmart delivery"
                className="w-full h-full object-cover"
              />
            </div>

            <div className="h-[250px] md:h-[360px] rounded-[24px] overflow-hidden bg-white border border-gray-100">
              <img
                src={aboutShipping2}
                alt="AgroSmart products"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </section>

        <section className="mt-6 md:mt-8 bg-white border border-gray-100 rounded-[28px] p-5 md:p-8">
          <h2 className="text-2xl md:text-3xl font-extrabold text-gray-950">
            {c.valuesTitle}
          </h2>

          <div className="mt-6 grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
            {c.values.map((item) => {
              const Icon = item.icon;

              return (
                <div
                  key={item.title}
                  className="rounded-[22px] bg-gray-50 border border-gray-100 p-4 md:p-5"
                >
                  <div className="flex h-10 w-10 items-center justify-center rounded-2xl bg-[#a7cf26]/10">
                    <Icon className="w-5 h-5 text-[#a7cf26]" />
                  </div>

                  <h3 className="mt-4 text-sm md:text-base font-extrabold text-gray-900">
                    {item.title}
                  </h3>

                  <p className="mt-2 text-xs md:text-sm leading-6 text-gray-500">
                    {item.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </section>

        <section className="mt-6 md:mt-8 grid grid-cols-1 lg:grid-cols-[0.9fr_1.1fr] gap-6 md:gap-8 items-center mb-6">
          <div className="h-[300px] md:h-[470px] rounded-[28px] overflow-hidden bg-white border border-gray-100">
            <img
              src={aboutImageLast}
              alt="AgroSmart customers"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="bg-white border border-gray-100 rounded-[28px] p-5 md:p-8">
            <h2 className="text-2xl md:text-4xl font-extrabold leading-tight text-gray-950">
              {c.whyTitle}
            </h2>

            <p className="mt-5 text-sm md:text-base leading-7 text-gray-500">
              {c.whyDesc}
            </p>

            <div className="mt-6 space-y-3">
              {c.whyItems.map((item) => (
                <div key={item} className="flex items-start gap-3">
                  <CheckCircle2 className="mt-0.5 w-5 h-5 text-[#a7cf26] flex-shrink-0" />
                  <p className="text-sm md:text-base leading-6 font-medium text-gray-700">
                    {item}
                  </p>
                </div>
              ))}
            </div>

            <div className="mt-8 rounded-[24px] bg-gray-950 p-5 md:p-6 text-white">
              <h3 className="text-xl md:text-2xl font-extrabold">
                {c.ctaTitle}
              </h3>

              <p className="mt-2 text-sm leading-6 text-white/70">
                {c.ctaDesc}
              </p>

              <Link
                to={isRu ? '/ru/contact' : '/contact'}
                className="mt-5 inline-flex items-center justify-center rounded-2xl bg-[#a7cf26] px-6 py-3 text-sm font-extrabold text-white hover:bg-[#96bc21]"
              >
                {c.ctaButton}
              </Link>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default AboutUsPage;